import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SessionSotrageService } from '../services/session-sotrage.service';
import { SweetServices } from '../services/sweet.services';

@Injectable({
  providedIn: 'root'
})
export class ValidarTokenGuard implements CanActivate {

  constructor(
    private ssstorage: SessionSotrageService, 
    private alerta: SweetServices) { }
  canActivate(): Promise<boolean> | boolean {
    let token = this.ssstorage.getCurrentToken();
    let payload = JSON.parse(atob(token.split('.')[1]));
    let expirado = this.expiro(payload.exp);

    if (expirado) {
      this.ssstorage.logout();
      return false;
    }
    return this.verificaRenovacion(payload.exp);
  }

  verificaRenovacion(fecha: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let tokenExp = new Date(fecha * 1000);
      let ahora = new Date();

      ahora.setTime(ahora.getTime() + (30 * 1000));
      if (tokenExp.getTime() > ahora.getTime()) {
        resolve(true);
      } else {
        this.alerta.AlertaRecargarToken();
      }
    });
  }

  expiro(fecha: number) {
    let ahora = new Date().getTime() / 1000;
    if (fecha < ahora) {
      return true;
    } else {
      return false;
    }
  }
}
